import { useQuery } from '@tanstack/react-query';
import { gamificationService } from '@services/gamificationService';

export const useGamification = () => {
  const {
    data: profile,
    isLoading: isLoadingProfile,
    refetch: refetchProfile,
  } = useQuery({
    queryKey: ['gamification', 'profile'],
    queryFn: gamificationService.getProfile,
  });

  const {
    data: leaderboard = [],
    isLoading: isLoadingLeaderboard,
  } = useQuery({
    queryKey: ['gamification', 'leaderboard'],
    queryFn: gamificationService.getLeaderboard,
  });

  const {
    data: definitions,
    isLoading: isLoadingDefinitions,
  } = useQuery({
    queryKey: ['gamification', 'definitions'],
    queryFn: gamificationService.getDefinitions,
    staleTime: 1000 * 60 * 60, // 1h - raramente muda
  });

  return {
    profile,
    leaderboard,
    definitions,
    isLoadingProfile,
    isLoadingLeaderboard,
    isLoadingDefinitions,
    refetchProfile,
  };
};

export default useGamification;
